import { FC } from 'react';
import { QuestionAnswersPage } from './question-answers.page';
import { useSessionStorage } from '../../../../../hooks';
import { getLocalStorageDistrictId } from '../../../../_core/utils';

export const QuestionAnswersDistrictLevelPage: FC = () => {
	const [sessionStorageDistrictId] = useSessionStorage('districtId');

	const districtId = sessionStorageDistrictId ?? getLocalStorageDistrictId();
	return <QuestionAnswersPage isAdminRoute={false} currentDistrictId={districtId} />;
};
